'use client';

import {OnePaneLayoutContainer} from '@udemy-v2/react-layout-components';
import styles from '@/features/organization-team-plan/organization-signup-text.module.scss';
import {Panel} from '@udemy-v2/react-structure-components';
import {BlockList} from '@udemy-v2/react-core-components';
import {Icon} from '@udemy-v2/icons';
import {useI18n} from '@udemy-v2/i18n';

import {TeamPlanPriceSummary} from '@/features/organization-team-plan/components/team-plan-price-summary';

interface OrganizationSignupTextProps {
    buyNow: boolean;
}

export function OrganizationSignupText({buyNow}: OrganizationSignupTextProps) {
    const {gettext} = useI18n();

    const description = buyNow
        ? gettext('Sign up to get ready-to-go learning.')
        : gettext('Simply create an account to get started.');

    return (
        <OnePaneLayoutContainer className={styles.container}>
            <p className={styles.description}>{description}</p>
            <Panel border={false} className={styles.panel}>
                <TeamPlanPriceSummary />
                <BlockList size="small">
                    <BlockList.Item
                        key={1}
                        icon={<Icon glyph="merchandise-course" label={false} />}
                    >
                        {gettext(
                            'Build and manage a complete learning program from learning to assessments.',
                        )}
                    </BlockList.Item>
                    <BlockList.Item key={2} icon={<Icon glyph="sparkles" label={false} />}>
                        {gettext(
                            "Provide practice with AI Role Plays, in-course practice tests, coding exercises, and more, so they're ready for the real thing.",
                        )}
                    </BlockList.Item>
                    <BlockList.Item key={3} icon={<Icon glyph="data-insight" label={false} />}>
                        {gettext("Understand your team's skills and show the impact of learning.")}
                    </BlockList.Item>
                </BlockList>
            </Panel>
        </OnePaneLayoutContainer>
    );
}
